import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Search } from 'basic-components';
import { FilesIcon } from 'basic-components/icons';
import { globalActions } from 'primary-components';

import { basicDatalakeActions } from 'actions/datalake';
import properties from 'resources/constants/properties.json';
import { routing } from 'routing';
import { GAUtils } from 'utils';

import HeaderNoSearch from 'primary/HeaderNoSearch';
import ProviderSelector from 'primary/ProviderSelector';

import AddNewFile from './AddNewFile';

import { When } from 'react-if';

import classNames from 'classnames';

const EMPTY_ARRAY = []
const DataLake = () => {
  const dispatch = useDispatch(),
        query = useSelector(state => state.datalakeState.query),
        sources = useSelector(state => state.globalState.sources) || EMPTY_ARRAY,
        localProvider = useMemo(() => sources.find(provider => provider.producerId === 0), [sources]),
        setQuery = useCallback(query => dispatch(basicDatalakeActions.onChange(query, "query")), [dispatch]),
        isSharingEnabled = useMemo(() => properties?.["sharing_enabled"] === "true", [])

  useEffect(() => {
    if(query) {
      GAUtils.sendEvent({
        category: "search",
        action: "search_file",
        label: "search"
      })
    }
  }, [query])

  useEffect(() => {
    GAUtils.sendEvent({
      category: "open",
      action: "open_dl",
      label: "open"
    })
    GAUtils.sendPageView(routing.LAKE.name)
  }, [])

  useEffect(() => () => {
    if (localProvider?.name) {
      dispatch(globalActions.onChange(localProvider.name, "localSource"))
    }
  }, [dispatch, localProvider])

  return (
    <div className="ng-office-app__authed__content ng-office-app__authed__content--data-lake">
      <HeaderNoSearch
          icon={(
            <FilesIcon
                color="grey-dark"
                height={12}
                width={12}
            />
          )}
          title="FILE BROWSER"
      >
        <div className={classNames(
          "ng-office-app__authed__content__search",
          { "ng-office-app__authed__content__search--with-sharing": isSharingEnabled }
        )}>
          <When condition={isSharingEnabled}>
            {() => (
              <ProviderSelector
                  menuGap={4}
                  withText={false}
              />
            )}
          </When>
          <Search
              autoFocus={false}
              defaultValue={query}
              onSearch={setQuery}
              placeholder="Search by name..."
              size="large"
              variant="outline"
          />
        </div>
      </HeaderNoSearch>
      <div className="ng-office-app__authed__content__body">
        <AddNewFile/>
      </div>
    </div>
  )
}

export default DataLake;